import { refreshSessionFx } from "@features/authentication";

export const initializeSession = async () => {
  try {
    await refreshSessionFx();
  } catch {
    console.error("Failed to initialize session");
  }
};
